import type { AxiosError, AxiosInstance } from "axios";

export function getContentTypeV2Builder(apiClient: AxiosInstance) {
  return async function getContentTypeV2(uuid: string): Promise<any> {
    try {
      const response = await apiClient.get(`/v2/pages/${uuid}/`);
      return response.data;
    } catch (error: unknown) {
      if ((error as AxiosError).response?.status === 404) {
        return null;
      } else {
        throw error;
      }
    }
  };
}
